var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeFiat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: 64,
    height: 64,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 28,5.25 H 4 C 2.482,5.252 1.252,6.482 1.25,8 V 24 C 1.252,25.518 2.482,26.748 4,26.75 H 28 C 29.518,26.748 30.748,25.518 30.75,24 V 8 C 30.748,6.482 29.518,5.252 28,5.25 Z m -25.25,5.5 h 26.5 v 2.5 H 2.75 Z M 4,6.75 H 28 C 28.69,6.751 29.249,7.31 29.25,8 V 9.25 H 2.75 V 8 C 2.751,7.31 3.31,6.751 4,6.75 Z m 24,18.5 H 4 C 3.31,25.249 2.751,24.69 2.75,24 v -9.25 h 26.5 V 24 c -0.001,0.69 -0.56,1.249 -1.25,1.25 z m -18,-4 H 6 c -0.414,0 -0.75,0.336 -0.75,0.75 0,0.414 0.336,0.75 0.75,0.75 v 0 h 4 c 0.414,0 0.75,-0.336 0.75,-0.75 0,-0.414 -0.336,-0.75 -0.75,-0.75 z m 10,0 h -6 c -0.414,0 -0.75,0.336 -0.75,0.75 0,0.414 0.336,0.75 0.75,0.75 v 0 h 6 c 0.414,0 0.75,-0.336 0.75,-0.75 0,-0.414 -0.336,-0.75 -0.75,-0.75 z",
    fill: "url(#paint0_linear_1855_33831)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_33831",
    x1: 16.2535,
    y1: 42.5184,
    x2: 45.3643,
    y2: 33.2162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1855_33831",
    x1: 35.0675,
    y1: 45.2661,
    x2: 41.7661,
    y2: 42.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFiat);
export default __webpack_public_path__ + "static/media/home-fiat.f26d42c5ded48ea51fc76a22b723d41d.svg";
export { ForwardRef as ReactComponent };